import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M6.40084 21V17.811C4.33472 16.2964 3.10685 13.8937 3.08984 11.332C3.08984 6.738 7.08984 3 11.9998 3C16.9098 3 20.9098 6.738 20.9108 11.332C20.9118 15.926 16.9108 19.662 12.0008 19.662C11.1359 19.6632 10.2749 19.5457 9.44184 19.313L6.40284 21H6.40084ZM11.0598 9.069L6.19484 14.232L10.6328 11.778L12.9328 14.172L17.7988 9.01L13.3648 11.464L11.0598 9.069Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Messenger"
);
